import {AbstractEvent} from "@/modules/base/events";
import {Season} from "@/modules/season/entity";

export class AfterSeasonEvaluationEvent extends AbstractEvent {
  constructor(
    public lastSeason: Season,
    public nextSeason: Season,
  ) {
    super();
  }
}